import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import globalnych styli z nowej lokalizacji
import './assets/css/index.css';
import '@fontsource/inter';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);